// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3ynnG","ranges":"BmiRanges_ranges__2TgC2"};